export const config = {
    baseUrl: 'https://api.edulley.com/'
    // baseUrl: 'http://localhost:8001/'
}